import { RoadmapNodeStatus } from '@/api/rest/resources/types/organization';
import { Logger } from '@/lib/logs/logger';

import { resolveThemeColor } from './resolveThemeColor';

export type RoadmapStyle = {
  color: string;
};

const exhaustivenessCheck = (roadmap: never): RoadmapStyle => {
  Logger.error(`No color defined for roadmap type "${roadmap}"`);
  return { color: resolveThemeColor('transparent') };
};

export const getStyleForRoadmapStatus = (roadmap: RoadmapNodeStatus): RoadmapStyle => {
  switch (roadmap) {
    case RoadmapNodeStatus.created:
      return { color: resolveThemeColor('neutral-black-8') };
    case RoadmapNodeStatus.ready:
      return { color: resolveThemeColor('warning-light') };
    case RoadmapNodeStatus.active:
      return { color: resolveThemeColor('primary-light') };
    case RoadmapNodeStatus.error:
      return { color: resolveThemeColor('error') };
    case RoadmapNodeStatus.closed:
      return { color: resolveThemeColor('primary-light') };
    default:
      return exhaustivenessCheck(roadmap);
  }
};
